<template>
  <section>
    <h2>Комната 5: {{ this.$store.state.Window5.nameWindow5 }}</h2>
    <v-card
      outlined
      class="mb-5 mt-5"
    >
      <v-row>
        <v-col>
          <v-checkbox
            @change="updateMountingCurtains5Method() || updateCost5Add()"
            v-model="mountingCurtains5"
            class="pl-5 pb-5"
            label="Монтаж карниза"
            color="red darken-3"
            true-value="Монтаж карниза"
            false-value=""
            hide-details
          />
          <v-checkbox
            @change="updateHangingCurtains5Method() || updateCost5Add ()"
            v-model="hangingCurtains5"
            class="pl-5 pb-5"
            label="Вывешивание штор"
            color="red darken-3"
            true-value="Вывешивание штор"
            false-value=""
            hide-details
          />
        </v-col>
        <v-col>
          <v-checkbox
            @change="updateBlackout5Method() || updateBlackout5withErker() || updateCost5Add()"
            :disabled="this.$store.state.Window5.nameWindow5 === 'Кухня'"
            v-model="blackout5"
            class="pl-5 pb-5"
            label="Ткань блэкаут"
            color="red darken-3"
            false-value=""
            true-value="Ткань блэкаут"
            hide-details
          />
          <v-checkbox
            @change="updateMountingRoll5Method() || updateCost5Add ()"
            v-model="mountingRoll5"
            class="pl-5 pb-5"
            label="Монтаж рулонной шторы"
            color="red darken-3"
            true-value="Монтаж рулонной шторы"
            false-value=""
            hide-details
          />
        </v-col>
        <v-col
          class="summaryCol"
        >
          <h3 class="pl-5">Вы заказали:</h3>
          <ul class="ml-5 mt-2">
            <li v-if="mountingCurtains5">{{ mountingCurtains5 }}</li>
            <li v-if="hangingCurtains5">{{ hangingCurtains5 }}</li>
            <li v-if="blackout5">{{ blackout5 }}</li>
            <li v-if="mountingRoll5">{{ mountingRoll5 }}</li>
          </ul>
        </v-col>
      </v-row>
    </v-card>
  </section>
</template>

<script>
export default {
  name: 'add5',
  data () {
    return {
    }
  },
  computed: {
    mountingCurtains5: {
      get () {
        return this.$store.state.AddOptions.mountingCurtains5
      },
      set (value) {
        this.$store.commit('updateMountingCurtains5', value)
      }
    },
    hangingCurtains5: {
      get () {
        return this.$store.state.AddOptions.hangingCurtains5
      },
      set (value) {
        this.$store.commit('updateHangingCurtains5', value)
      }
    },
    blackout5: {
      get () {
        return this.$store.state.AddOptions.blackout5
      },
      set (value) {
        this.$store.commit('updateBlackout5', value)
      }
    },
    mountingRoll5: {
      get () {
        return this.$store.state.AddOptions.mountingRoll5
      },
      set (value) {
        this.$store.commit('updateMountingRoll5', value)
      }
    }
  },
  methods: {
    updateMountingCurtains5Method () {
      this.$store.commit('updateMountingCurtains5Method')
    },
    updateHangingCurtains5Method () {
      this.$store.commit('updateHangingCurtains5Method')
    },
    updateBlackout5Method () {
      this.$store.commit('updateBlackout5Method')
    },
    updateBlackout5withErker () {
      this.$store.commit('updateBlackout5withErker')
    },
    updateMountingRoll5Method () {
      this.$store.commit('updateMountingRoll5Method')
    },
    updateCost5Add () {
      this.$store.commit('updateCost5Add')
    }
  }
}
</script>

<style>

</style>
